<template>
    <div class="folder_templates w-100" v-if="isMain == 'home'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.home.tableFolderLoader === 1">
        <!-- <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.home.tableFolderLoader === 3"> -->
            <ShimmerFolder />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>
            <FolderName :myArray="$store.state.home.folderList" v-if="isMain == 'home'" :isMain="'home'"/>    
            <div class="col-lg-12">     
                <div v-if="$store.state.home.currentFolderPage < $store.state.home.totalFolderPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFolderListingData(true)"
                        :disabled="$store.state.home.isHomeLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>      
            </div> 
        </div>
    </div>
    <div class="folder_templates w-100" v-else-if="isMain == 'starred'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.starred.tableFolderLoader === 1">
            <ShimmerFolder />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>        
            <FolderName :myArray="$store.state.starred.folderList" :isMain="'starred'"/>    
            <div class="col-lg-12">     
                <div v-if="$store.state.starred.currentFolderPage < $store.state.starred.totalFolderPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFolderListingData(true)"
                        :disabled="$store.state.home.isHomeLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>     
            </div>           
        </div>
    </div>
    <div class="folder_templates w-100" v-else-if="isMain == 'sharedWithMe'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.sharedWithMe.tableFolderLoader === 1">
            <ShimmerFolder />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>        
            <FolderName :myArray="$store.state.sharedWithMe.folderList" :isMain="'sharedWithMe'"/>    
            <div class="col-lg-12">     
                <div v-if="$store.state.sharedWithMe.currentFolderPage < $store.state.sharedWithMe.totalFolderPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFolderListingData(true)"
                        :disabled="$store.state.home.isHomeLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>     
            </div>           
        </div>
    </div>
    <div class="folder_templates w-100" v-else-if="isMain == 'trash'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.trash.tableFolderLoader === 1">
            <ShimmerFolder />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>        
            <FolderName :myArray="$store.state.trash.folderList" :isMain="'trash'"/>            
            <div class="col-lg-12">     
                <div v-if="$store.state.trash.currentFolderPage < $store.state.trash.totalFolderPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFolderListingData(true)"
                        :disabled="$store.state.home.isHomeLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>        
            </div>       
        </div>
    </div>
</template>

<script>
import FolderName from './FolderName.vue'
import ShimmerFolder from './ShimmerFolder.vue'
import {
        startLoader,
        finishLoader
} from '../../utils/helper.js'
import 
    { post } 
from '../../utils/api.js'
import { useRoute } from 'vue-router';
import axios from 'axios'
export default {
    name: 'ListingFolderData',
    components: {
        FolderName,
        ShimmerFolder,
    },
    data() {
        return {
            folderList: [],
            pageSize: 2,
            isLoading: false,
            isLoadingMore: false,
        }
    },
    props: {
        isMain: {
            type: String,
            default: ''
        }
    },
    async mounted() {
        if (this.$store.state.isActiveToken != '1') {
            // console.log(this.currentDate);
        } else {
            const route = useRoute();
            if(route.name == 'Home'){
                if(this.$store.state.home.currentFolderPage > 1){
                    await this.reloadHomeFolder();
                }else{
                    await this.loadFolderListingData();
                }
            }else if(route.name == 'Starred'){
                if(this.$store.state.starred.currentFolderPage > 1){
                    await this.reloadStarredFolder();
                }else{
                    await this.loadFolderListingData();
                }
            }else if(route.name == 'Trash'){
                if(this.$store.state.trash.currentFolderPage > 1){
                    await this.reloadTrashFolder();
                }else{
                    await this.loadFolderListingData();
                }
            }else if(route.name == 'ShareWithMe'){
                if(this.$store.state.sharedWithMe.currentFolderPage > 1){
                    await this.reloadSharedWithMeFolder();
                }else{
                    await this.loadFolderListingData();
                }
            }else{
                await this.loadFolderListingData();
            }
        }
    },
    computed: {
        iAT() {
            return this.$store.state.user.roleId
        },
        reNew() {
            return this.$store.state.home.reLoadFolder
        },
        reLoad() {
            return this.$store.state.home.reLoadFoldercomponent
        },
        reStarredHomeLoad() {
            return this.$store.state.home.reLoadFolderHomeStarredComponent
        },
        reTrashLoad() {
            return this.$store.state.home.reLoadFileTrashComponent
        },
    },
    watch: {
        async iAT(newValue) {
            if (this.$store.state.user.roleId != '') {
                await this.loadFolderListingData();
            }
            return newValue
        },
        async reNew(newValue) {
            await this.loadFolderListingData();
            return newValue
        },
        async reLoad(newValue) {
            const routeName = this.$route.name;
            if(routeName == 'Home'){
                await this.reloadHomeFolder();
            }else if(routeName == 'Starred'){
                await this.reloadStarredFolder();
            }else if(routeName == 'Trash'){
                await this.reloadTrashFolder();
            }else if(routeName == 'ShareWithMe'){
                await this.reloadSharedWithMeFolder();
            }else{
                await this.reloadHomeFolder();
            }
            return newValue
        },
        async reStarredHomeLoad(newValue) {
            const routeName = this.$route.name;
            if(routeName == 'Home'){
                await this.reloadHomeFolder();
            }else if(routeName == 'Starred'){
                await this.reloadStarredFolder();
            }else if(routeName == 'Trash'){
                await this.reloadTrashFolder();
            }else if(routeName == 'ShareWithMe'){
                await this.reloadSharedWithMeFolder();
            }else{
                await this.reloadHomeFolder();
            }
            return newValue
        },
        async reTrashLoad(newValue) {
            await this.reloadTrashFolder();
            return newValue
        },
    },
    methods: {
        startLoader,
        finishLoader,
        async loadHomeFolderListingData() {
            this.startLoader();
            if(this.$store.state.home.removeFolderStarrd == 2){
                this.$store.state.home.currentFolderPage = 1 
                this.$store.state.home.removeFolderStarrd = 1    
            }

            let _post = {}
            _post = {
                folderName: this.folderName,
                pageLength: this.$store.state.pageSize,
                page: this.$store.state.home.currentFolderPage,
                test: 'LF-219',
                // limit: 8,
            }
            let uidParam = localStorage.getItem("aid");
            if (uidParam) {
                _post.user_id = uidParam;
            }
            // this.$store.state.home.tableFolderLoader = 1
            const resp = await post('files/list-folders', _post)
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {

                if(this.$store.state.home.currentFolderPage > 1){
                    const newFiles = resp.data.data.folders;
                    if(this.$store.state.home.removeFolderStarrd == 2){
                        this.$store.state.home.folderList = [] 
                    }
                    // Get existing keys
                    const existingKeys = new Set(this.$store.state.home.folderList.map(f => f._id));
    
                    // Filter new files that aren't already in the list
                    const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f._id));
    
                    // Append unique files
                    this.$store.state.home.folderList.push(...uniqueNewFiles);

                }else{
                    this.$store.state.home.folderList = resp.data.data.folders;
                }
                // Loader state
                this.$store.state.home.tableFolderLoader = this.$store.state.home.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalFolders || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.home.totalFolderPages = totalCount;
                this.$store.state.home.totalFolders = resp.data.data.totalFolders || 1;


                this.finishLoader();
            }  
        },
        async loadStarredFolderListingData() {
            this.startLoader();
            let resp = []
            if(this.$store.state.starred.removeFolderStarrd == 2){
                this.$store.state.starred.currentFolderPage = 1 
                this.$store.state.starred.removeFolderStarrd = 1    
            }
            resp = await axios.get(process.env.VUE_APP_API_URL + 'starred/folders', {
                params: {
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.starred.currentFolderPage,
                }
            })
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                if(this.$store.state.starred.currentFolderPage > 1){
                    const newFiles = resp.data.data.folders;
    
                    if(this.$store.state.starred.removeFolderStarrd == 2){
                        this.$store.state.starred.folderList = [] 
                    }
                    // Get existing keys
                    const existingKeys = new Set(this.$store.state.starred.folderList.map(f => f._id));
    
                    // Filter new files that aren't already in the list
                    const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f._id));
    
                    // Append unique files
                    this.$store.state.starred.folderList.push(...uniqueNewFiles);

                }else{
                    this.$store.state.starred.folderList = resp.data.data.folders;
                }
                // Loader state
                this.$store.state.starred.tableFolderLoader = this.$store.state.starred.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.starred.totalFolderPages = totalCount;


                this.finishLoader();
            }  
        },
        async loadSharedWithMeFolderListingData() {
            this.startLoader();
            let resp = []
            if(this.$store.state.sharedWithMe.removeFolderStarrd == 2){
                this.$store.state.sharedWithMe.currentFolderPage = 1 
                this.$store.state.sharedWithMe.removeFolderStarrd = 1    
            }
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/share-with-me-folders', {
                params: {
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.sharedWithMe.currentFolderPage,
                }
            })
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                if(this.$store.state.sharedWithMe.currentFolderPage > 1){
                    const newFiles = resp.data.data.files;
                    if(this.$store.state.sharedWithMe.removeFolderStarrd == 2){
                        this.$store.state.sharedWithMe.folderList = [] 
                    }
                    // Get existing keys
                    const existingKeys = new Set(this.$store.state.sharedWithMe.folderList.map(f => f._id));
    
                    // Filter new files that aren't already in the list
                    const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f._id));
    
                    // Append unique files
                    this.$store.state.sharedWithMe.folderList.push(...uniqueNewFiles);
                }else{
                    this.$store.state.sharedWithMe.folderList = resp.data.data.files;
                }


                // Loader state
                this.$store.state.sharedWithMe.tableFolderLoader = this.$store.state.sharedWithMe.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.sharedWithMe.totalFolderPages = totalCount;

                this.finishLoader();
            }  
        },
        async loadTrashFolderListingData() {
            this.startLoader();
            let resp = []
            if(this.$store.state.trash.removeFolderStarrd == 2){
                this.$store.state.trash.currentFolderPage = 1 
                this.$store.state.trash.removeFolderStarrd = 1    
            }
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/trash-folders', {
                params: {
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.trash.currentFolderPage,
                }
            })
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.folders;
                if(this.$store.state.trash.removeFolderStarrd == 2){
                    this.$store.state.trash.folderList = [] 
                }
                // Get existing keys
                const existingKeys = new Set(this.$store.state.trash.folderList.map(f => f.key));

                // Filter new files that aren't already in the list
                const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f.key));

                // Append unique files
                this.$store.state.trash.folderList.push(...uniqueNewFiles);

                // Loader state
                this.$store.state.trash.tableFolderLoader = this.$store.state.trash.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.trash.totalFolderPages = totalCount;


                this.finishLoader();
            }  
        },
        async reloadStarredFolder() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.starred.currentFolderPage
            
            this.startLoader();
            let resp = []
            resp = await axios.get(process.env.VUE_APP_API_URL + 'starred/folders', {
                params: {
                    pageLength: psadaageSize,
                    page: 1,
                    test: 1,
                }
            })
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.folders;
                if(this.$store.state.starred.removeFolderStarrd == 2){
                    this.$store.state.starred.folderList = [] 
                }
                this.$store.state.starred.tableFolderLoader = this.$store.state.starred.folderList.length > 0 ? 3 : 2;
                this.$store.state.starred.folderList =  newFiles

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.starred.totalFolderPages = totalCount;
                this.finishLoader();
            }  
        },
        async reloadSharedWithMeFolder() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.sharedWithMe.currentFolderPage
            
            this.startLoader();
            let resp = []
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/share-with-me-folders', {
                params: {
                    pageLength: psadaageSize,
                    page: 1,
                    test: 1,
                }
            })
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.files;
                if(this.$store.state.sharedWithMe.removeFolderStarrd == 2){
                    this.$store.state.sharedWithMe.folderList = [] 
                }
                this.$store.state.sharedWithMe.folderList =  newFiles
                this.$store.state.sharedWithMe.tableFolderLoader = this.$store.state.sharedWithMe.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalFolders || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.sharedWithMe.totalFolderPages = totalCount;

                this.finishLoader();
            }  
        },
        async reloadTrashFolder() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.trash.currentFolderPage
            
            this.startLoader();
            let resp = []
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/trash-folders', {
                params: {
                    pageLength: psadaageSize,
                    page: 1,
                    test: 1,
                }
            })
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.folders;
                if(this.$store.state.trash.removeFolderStarrd == 2){
                    this.$store.state.trash.folderList = [] 
                }
                this.$store.state.trash.folderList =  newFiles
                this.$store.state.trash.tableFolderLoader = this.$store.state.trash.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalFolders || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.trash.totalFolderPages = totalCount;

                this.finishLoader();
            }  
        },
        async reloadHomeFolder() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.home.currentFolderPage
            
            this.startLoader();
            
            let _post = {}
            _post = {
                folderName: this.folderName,
                pageLength: psadaageSize,
                page: 1,
                test: 'LF-464',
            }
            let uidParam = localStorage.getItem("aid");
            if (uidParam) {
                _post.user_id = uidParam;
            }

            const resp = await post('files/list-folders', _post)
            this.$store.state.home.isHomeLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.folders;
                if(this.$store.state.home.removeFolderStarrd == 2){
                    this.$store.state.home.folderList = [] 
                }
                this.$store.state.home.folderList =  newFiles

                this.$store.state.home.tableFolderLoader = this.$store.state.home.folderList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalFolders || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.home.totalFolderPages = totalCount;
                this.$store.state.home.totalFolders = resp.data.data.totalFolders || 1;
                this.finishLoader();
            }  
        },
        async loadFolderListingData(loadMore = false) {
            try {
                this.startLoader();
                // let resp = []
                if(this.isMain == 'home') {
                    if (!loadMore) {
                        // this.startLoader();
                        // this.fileList = [];
                        // this.currentFolderPage = 1;
                    } else {
                        this.$store.state.home.currentFolderPage += 1;
                        this.$store.state.home.isHomeLoadingMore = true;
                    }
                          
                    this.loadHomeFolderListingData();
                } else if (this.isMain == 'starred') {
                    if (!loadMore) {
                        // this.startLoader();
                        // this.fileList = [];
                        // this.currentFolderPage = 1;
                    } else {
                        this.$store.state.starred.currentFolderPage += 1;
                        this.$store.state.home.isHomeLoadingMore = true;
                    }
                    this.loadStarredFolderListingData();
                } else if (this.isMain == 'sharedWithMe') {
                    if (!loadMore) {
                        // this.startLoader();
                        // this.fileList = [];
                        // this.currentFolderPage = 1;
                    } else {
                        this.$store.state.sharedWithMe.currentFolderPage += 1;
                        this.$store.state.home.isHomeLoadingMore = true;
                    }
                    this.loadSharedWithMeFolderListingData();
                    
                } else if (this.isMain == 'trash') {
                    if (!loadMore) {
                        // this.startLoader();
                        // this.fileList = [];
                        // this.currentFolderPage = 1;
                    } else {
                        this.$store.state.trash.currentFolderPage += 1;
                        this.$store.state.home.isHomeLoadingMore = true;
                    }
                    this.loadTrashFolderListingData();
                    
                } else {
                    if (!loadMore) {
                        // this.startLoader();
                        // this.fileList = [];
                        // this.currentFolderPage = 1;
                    } else {
                        this.$store.state.home.currentFolderPage += 1;
                        this.$store.state.home.isHomeLoadingMore = true;
                    }
                    this.loadHomeFolderListingData();
                }
                
            } catch (error) {
                this.finishLoader();
                console.error('Error:', error.response?.data || error.message)
            }
        },
    },
}
</script>
